import { Box, DashboardModule, FormField } from '@domain-group/suit-theme'

import type { EntitiesState } from '@redux/entities'

import useTeamMembers from '@hooks/useTeamMembers'
import useTeams from '@hooks/useTeams'

import type { GroupedTasks } from '../../hooks/useGroupedTasks'

import User from './User'

interface TeamOverviewProps {
  callbacks: {
    selectTeamId: (teamId: number) => void,
  },
  entities: EntitiesState,
  groupedTasks: GroupedTasks,
  selectedTeamId: number,
  teamsPayload: ReturnType<typeof useTeams>,
}

const TeamOverview = (props: TeamOverviewProps) => {
  const {
    callbacks: { selectTeamId },
    entities: { images, teamMembers, users },
    groupedTasks,
    selectedTeamId,
    teamsPayload: { filteredTeams },
  } = props

  const teamMembersPayload = useTeamMembers({
    filters: {
      team_id: selectedTeamId,
    },
  })

  const taskGroupsArray = Object.values(groupedTasks)
  const userIdsWithTasks = taskGroupsArray.map(taskGroup => taskGroup.assignee_id)

  const { filteredTeamMembers } = teamMembersPayload
  const teamMembersWithNoTasks = filteredTeamMembers.filter((teamMember) => {
    const { user_id } = teamMember
    return !userIdsWithTasks.includes(user_id)
  })

  return (
    <DashboardModule title="Team Workload">
      <Box flexDirection="column" padding="large" paddingBottom="0">
        <FormField label="Teams">
          <select name="team_id" value={selectedTeamId} onChange={e => selectTeamId(Number(e.target.value))}>
            <option value="">Please Select...</option>
            {filteredTeams.map(team => (
              <option key={team.id} value={team.id}>
                {team.title}
              </option>
            ))}
          </select>
        </FormField>

        {!!taskGroupsArray.length && (
          <FormField label="Team Members" marginTop="large">
            {taskGroupsArray.map((taskGroup) => {
              const { assignee_id, items, teamMemberId } = taskGroup

              // @ts-expect-error TS7015
              const teamMember = teamMembers[teamMemberId] || {}
              // @ts-expect-error TS7015
              const user = users[assignee_id] || {}
              const image = images[user.image] || {}

              return <User image={image} itemCount={items.length} key={user.id} teamMember={teamMember} user={user} />
            })}
          </FormField>
        )}

        {!!teamMembersWithNoTasks.length && (
          <FormField label="Members with No Tasks" marginTop="large">
            {teamMembersWithNoTasks.map((teamMember) => {
              const { user_id } = teamMember

              const user = users[user_id] || {}
              // @ts-expect-error TS2538
              const image = images[user.image] || {}

              return <User image={image} itemCount={0} key={user.id} teamMember={teamMember} user={user} />
            })}
          </FormField>
        )}
      </Box>
    </DashboardModule>
  )
}

export default TeamOverview
